export const SCAN_TYPE_LABELS = {
    full: 'Full Security Scan',
    ssl: 'SSL/TLS Certificate Check',
    headers: 'Security Headers Check',
    ports: 'Open Port Scan',
    dast: 'Dynamic Application Testing',
    'api-fuzz': 'API Fuzzing',
};
export const SCAN_TYPE_DESCRIPTIONS = {
    full: 'Runs all available security checks on your site. This is the most thorough option.',
    ssl: 'Checks if your site uses secure connections (HTTPS) properly and if certificates are valid.',
    headers: 'Checks if your site has the right security settings to protect visitors from common attacks.',
    ports: 'Scans for open network ports that could be entry points for attackers.',
    dast: 'Actively tests your site for vulnerabilities like injection attacks and cross-site scripting.',
    'api-fuzz': 'Tests your API endpoints with unexpected inputs to find security weaknesses.',
};
export const SCAN_TYPE_DURATIONS = {
    full: '5-15 minutes',
    ssl: '30 seconds',
    headers: '15 seconds',
    ports: '2-5 minutes',
    dast: '5-10 minutes',
    'api-fuzz': '3-8 minutes',
};
//# sourceMappingURL=scan.js.map